module.exports = __webpack_public_path__ + "img/bg7.009392bf.png";